import { Analytics } from '@gloow/apiconsumer'

let AnalyticsService = new Analytics()
export default AnalyticsService
